/**
 * The default field value that indicates that the first value should be chosen.
 *
 * @type {Symbol}
 */
export const FIELD_DEFAULT_REPLACE_WITH_FIRST = Symbol('FIELD_DEFAULT_REPLACE_WITH_FIRST');

export const FIELD_CONVERSION_RECORD_LIMIT = 1000;
